import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
import { Loading } from 'element-ui'
import { Message } from '@qs/ui'
import {
  getToken,
  getTenantId,
  gotoNewWindow,
  setResourceFailedNum,
  getResourceFailedNum,
} from '@/utils/auth' // 验权
import { setWindowAuthInfo, getRouteJudge } from '@/utils/multiTenantUtil'
import { validateQuerySchema } from '@/utils/querySchema'
import { useViolationWarnAlert } from '@/utils/useWarnAlert.js'
import * as utils from '@/utils/index'
import { purchaseMallLogIn } from '@/api/login'
import { upRoute } from '@/utils/ba.js'
import usePrivacy from '@/components/PrivacySwitch/privacyService'
import { trackPageEnter, trackPageLeave } from '@/utils/trackReport'

const noLogin = ['/login']
const whiteList = ['/welcome', '/404'] // 不重定向白名单
const baseName = router.history.base.replace('/', '') // 获取平台name

const { getPrivacyRemote } = usePrivacy()

// eslint-disable-next-line no-shadow
function doGetRoureceByToken(to, store, next) {
  store
    .dispatch('getResourceByToken', {
      token: getToken(),
      baseName,
    })
    .then(() => {
      // 请求数据
      router.addRoutes(store.getters.addRouters)
      store.commit('SET_ASYN_ROUTERS', router.options.routes)
      next({ ...to, replace: true })
      setResourceFailedNum(true)
    })
    .catch((e) => {
      const failedCount = getResourceFailedNum()
      if (failedCount > 3) {
        setResourceFailedNum(true)
        store.dispatch('FedLogOut').then(() => {
          Message.warning(
            '多次尝试依然资源获取失败，可能网络环境不佳，请尝试重新登录',
          )
          next({ path: '/login' })
        })
      } else {
        setResourceFailedNum()
        Message.warning('账号暂无角色信息，请联系管理员绑定角色')
        doGetRoureceByToken(to, store, next)
      }
    })
}

router.beforeEach(async (to, from, next) => {
  // 强制移除所有 el-datePicker 日期面板
  const datePickers = document.querySelectorAll('.el-picker-panel')
  datePickers.forEach((datePicker) => {
    datePicker.parentNode?.removeChild(datePicker)
  })

  // 特定路由请求违章查询接口进行弹窗
  const violation_scan_list = ['workbench_index', 'driver_customer', 'for_rent_sign_contract', 'vehicle_manage']

  if (violation_scan_list.includes(to.name) && getToken() && getTenantId() > -1) {
    useViolationWarnAlert()
  }

  // 上报埋点
  upRoute(to, from)
  trackPageLeave(from.name)
  // 跳转维保商城
  if (to.name === 'maintenanceMall') {
    next(false)
    purchaseMallLogIn({ phone: store.state.user.userInfo.userMobile }).then((res) => {
      if (res && res.code === 1) {
        utils.newOpenPage(res.data, 'shop')
      }
    }).finally(() => {
      window.location.reload()
    })

    return false
  }

  if (process.env.NODE_ENV === 'development') {
    validateQuerySchema(to)
  }

  const toPath = to.path.split('/')
  if (!whiteList.includes(`/${toPath[1]}`)) {
    if (toPath.length === 2) {
      const Menu = store.getters.addRouters.find((r) => r.name === toPath[1])
      if (Menu && Menu.children && Menu.children.length) {
        const item = Menu.children.find((r) => !r.hidden)
        if (item) {
          next({
            path: item.path,
          })
          return false
        }
      }
    }
  }
  utils.logEvent(to)
  NProgress.start()
  // false表示通过校验，true表示未通过校验,getTenantId()为-1的时候是跳转到登录，走之前处理
  if (getRouteJudge(to.path) && Number(getTenantId()) !== -1) {
    Loading.service()
    Message.error('账户租户权限更新，返回首页。')
    next(false)
    setTimeout(() => {
      gotoNewWindow()
    }, 2000)
  } else if (getToken() && getTenantId() > -1) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      const { userInfo } = store.getters
      if (getToken() && !userInfo.userName) {
        await Promise.all([store.dispatch('GetUserInfo', getToken())])
      }
      if (store.getters.addRouters.length === 0) {
        // 没有资源数据
        doGetRoureceByToken(to, store, next)
        // 刷新页面时获取全局隐私标识
        getPrivacyRemote()
      } else {
        /**  进入页面后 缓存当前 路由 技改需求 20231031 https://bailongma.yuque.com/hhwu0d/nvrent/ivvalkzuuhe5yged */
        if (to.name && to.path !== '/login' && to.path !== '/welcome') {
          store.commit('ADD_CACHE_ROUTE', {
            prevRoute: from,
            cacheRoute: to,
          })
        }
        // 判断是不是公司维度
        if (to.query.type === 'shop') {
          utils.jumpShopAddress(next)
          return
        }
        next()
      }
    }
  } else if (noLogin.indexOf(to.path) !== -1) {
    next()
  } else {
    next('/login') // 否则全部重定向到登录页
    NProgress.done()
  }
})

router.afterEach((to) => {
  setWindowAuthInfo()
  if (!whiteList.includes(to.path) && to.matched.length === 0) {
    router.push('/noPermission')
  }
  const { addRouters } = store.state.permission || {}
  const name = addRouters.length && addRouters[0].name
  if (name && to.path.split('/')[1] === 'welcome') {
    router.push(`/${name}`)
  }

  utils.setBreadcrumb(to, store, false)
  NProgress.done() // 结束Progress
  trackPageLeave(to.name)
})
